import React from "react";
import SVGIcon, { SVGIconName } from "web/react/components/svg-icon/svg-icon";
import { HStack } from "web/react/emo/h-stack";
import { BaseText } from "web/react/emo/shared/components/base-text";
import { Sprinkles } from "web/react/emo/sprinkles.css";
import * as styles from "./link.css";

export interface LinkProps {
    href: string;
    title: string;
    icon?: SVGIconName;
    color?: Sprinkles["color"];
    dataTestId?: string;
    bold?: boolean;
    className?: string;
}

export function Link({
    href,
    title,
    icon,
    color,
    dataTestId,
    bold = true,
    className,
}: LinkProps): React.ReactElement {
    return (
        <HStack spacing="xxxs" align="center">
            {icon && <SVGIcon className={styles.icon} name={icon} />}
            <a className={className} data-testid={dataTestId || "link"} href={href}>
                <BaseText
                    className={styles.link}
                    as="p"
                    textStyle={bold ? "body-s-bold" : "body-s"}
                    color={color || "secondaryBrand"}
                >
                    {title}
                </BaseText>
            </a>
        </HStack>
    );
}
